import React, { Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomHelmet from "../../component/reusable/Helmet";
import { FaArrowLeftLong } from "react-icons/fa6";
import mockInterview1 from "../../images/howuse/mockInterview1.png";
import mockInterview2 from "../../images/howuse/mockInterview2.png";
import mockInterview3 from "../../images/howuse/mockInterview3.png";
import mockInterview4 from "../../images/howuse/mockInterview4.png";
import ssb_mentor_1 from "../../images/howuse/ssb_mentor_1.png";
import ssb_mentor_2 from "../../images/howuse/ssb_mentor_2.png";
const MockInterviewHowUse = () => {
  const navigate = useNavigate();
  return (
    <Fragment>
      <CustomHelmet
        title="SSB-GPT: Your SSB Interview Self Preparation Tool"
        description="Prepare effectively for your SSB/AFSB/NSB/ interview with SSB-GPT, a free self-preparation tool."
      />
      {/* <GptHeader /> */}

      <section className="how_UseClassRoom_main">
        <div className="container">
          <div className="bacbtnWthHeading">
            <button
              title="back"
              className="backBtn"
              onClick={() => navigate(-1)}
            >
              <FaArrowLeftLong />
            </button>
            <h1 className="main_heading">
              How to Use Mock Interview Classroom
            </h1>
          </div>
        </div>
        <div className="howUse_content container">
          <p>Welcome, Alpha Warriors!</p>
          <p>
            The Personal Interview is a pivotal part of the SSB process,
            offering you the chance to directly impress the Interviewing Officer
            (IO) with your personality, confidence, and Officer-Like Qualities
            (OLQs). It’s your moment to demonstrate how well-suited you are for
            the armed forces.
          </p>
          <p>
            To help you prepare thoroughly, AI SSB Mentor Captain Alpha will
            conduct mock interviews, simulating real SSB scenarios. These
            sessions are designed to refine your responses, build confidence,
            and provide expert feedback to help you ace your interview.
          </p>
          <p>
            Get ready to train and excel under the guidance of Captain Alpha! 🚀
          </p>
          <p>Here’s how you can join and start practicing:</p>
          <h2 className="subHeading">
            Step-by-Step Guide to Join the Mock Interview Classroom
          </h2>
          <h3 className="tab_heading">
            <b>Step 1.</b> Navigate to the Home Page {`>>`}{" "}
            <Link to="/chat">Ask Your SSB Mentor Now</Link>{" "}
          </h3>
          <img
            src={ssb_mentor_1}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 2.</b> Click <b>“Choose Classroom”</b>
          </h3>
          <img
            src={ssb_mentor_2}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 3.</b> Choose <b>“Mock Interview”</b>
          </h3>
          <img
            src={mockInterview1}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 4.</b> Click the <b>“Start”</b> button
          </h3>
          <img
            src={mockInterview2}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 5.</b> Read the instructions carefully and Click the “Start”
            button
          </h3>
          <p>
            Read the instructions carefully so that your mock interview can run
            smoothly without any interruption. Click on the “Start” button.
          </p>
          <img
            src={mockInterview3}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />
          <br />
          <h3 className="tab_heading">
            <b>Step- 6.</b> Familiarize yourself with your classroom interface
          </h3>
          <img
            src={mockInterview4}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />
          <br />
          <br />

          <ul>
            <li>
              Whatever you speak will be automatically transcribed here. If you
              notice any errors due to background noise, misinterpretation, or
              other reasons, you can correct them before submitting.
            </li>
            <li>
              If the automatic transcription stops for any reason, click the mic
              icon to refresh it.
            </li>
            <li>
              Once you’ve ensured your answer is correctly typed, click Submit.
            </li>
          </ul>
          <br />
          <p>
            This way, your mock interview practice can continue seamlessly for
            as long as you need.
          </p>
          <br />
          <p>
            By following these steps, you can ensure a smooth and productive
            preparation for your SSB Personal Interview. For further assistance,
            feel free to reach out to support!
          </p>
          <br />
          <p>
            Jai Hind! <br />
            Over and out!
          </p>
        </div>
      </section>
      {/* <Footer /> */}
    </Fragment>
  );
};

export default MockInterviewHowUse;
